import { TermBox } from "@/components/atoms/TermBox";
import { Font } from "@moneyforward/mfx_biz_react_components";

export const TermBoxPlanCancel = () => {
  return (
    <TermBox header="【プラン解約における注意事項】">
      <Font variant="mb">
        プランを解約するとご利用中のサービスはすべて利用終了となります。来月より各サービスのご利用ができなくなります。
      </Font>
      <ul>
        <li>利用終了となるサービスについて、データの引き継ぎはできません。</li>
        <li>
          これまでの利用の中で蓄積したデータで、今後必要なものについては別途記録をお取りいただくことをおすすめします。
        </li>
        <li>
          各サービスおよび機能の利用終了日はプラン解約手続きされた月の末日となります。それまでは引き続き利用いただけます。
        </li>
      </ul>
    </TermBox>
  );
};
